import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + "/admin/payment/tax";
};



export const submitInvoice = (data) => {
  const url = `${baseURL()}/submitInvoice`;  
  return axios.post(url, data);
};

export const getDocumentDetail = (data) => {
  const url = `${baseURL()}/getDocumentDetail`;  
  return axios.post(url, data);
};

export const cancelSubmission = (data) => {
  const url = `${baseURL()}/cancelSubmission`;    
  return axios.post(url, data);
};

export const validateTIN = (id, data) => {
  const url = `${baseURL()}/validateTIN/${id}`;    
  return axios.post(url, data);
};

export const addTaxpayer = (data) => {
  const url = `${baseURL()}/taxpayer/add`;    
  return axios.post(url, data);
};

export const loadTaxSettings = (data) => {
  const url = `${baseURL()}/getSettings`;    
  return axios.post(url, data);
};

export const setDefaultTaxpayer = (id, data) => {
  const url = `${baseURL()}/taxpayer/setDefault/${id}`;    
  return axios.post(url, data);
};
